<script lang="ts">
	/**
	 * Cart link with a live item count.
	 *
	 * The count comes from WooCommerce, so it loads on mount rather than being
	 * rendered at build time — every visitor's cart differs, and the page itself
	 * is static.
	 */
	import { onMount } from 'svelte';
	import { cart } from '$lib/checkout/cart.svelte';
	import { getLocale } from '$lib/paraglide/runtime';
	import { prefixPath, type Locale } from '$lib/i18n';

	const href = $derived(prefixPath('/cart', getLocale() as Locale));

	onMount(() => cart.load());
</script>

<a {href} class="relative inline-flex items-center p-2 text-body" aria-label="Cart">
	<svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
		<path
			stroke-linecap="round"
			stroke-linejoin="round"
			stroke-width="1.5"
			d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 0 0-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 0 0-16.536-1.84M7.5 14.25 5.106 5.272M6 20.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm12.75 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"
		/>
	</svg>
	{#if cart.count > 0}
		<span
			class="bg-brand-500 absolute -top-0.5 -right-0.5 min-w-5 rounded-full px-1 text-center text-xs font-bold text-ink-500"
		>
			{cart.count}
		</span>
	{/if}
</a>
